// Live-share viewer session (cross-screen-overview-and-live-share.md §2.3–2.4).
// GROUNDWORK ONLY: nothing mints a viewer session yet — a later wave wires the
// rate-limited /api/share/auth exchange (the share password is deliberately
// weak, so server-side rate limiting is non-negotiable) and hands back the
// shape below. Until then getViewerSession() returns null and workspace visits
// without an owner session render the ShareGate stub.

const STORAGE_KEY='command-center-viewer-session';

// Session shape: { token, shareId, screenSlug, companySlug, expiresAt }.
// Expired, malformed or absent rows all read as "no viewer session".
export function getViewerSession() {
  try {
    const raw=localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const session=JSON.parse(raw);
    if (!session?.token || typeof session.expiresAt!=='number') {
      clearViewerSession();
      return null;
    }
    if (Date.now()>=session.expiresAt) {
      clearViewerSession();
      return null;
    }
    return session;
  } catch {
    clearViewerSession();
    return null;
  }
}

export function setViewerSession(session) {
  if (!session?.token) return;
  localStorage.setItem(STORAGE_KEY,JSON.stringify({
    token:session.token,
    shareId:session.shareId||null,
    screenSlug:session.screenSlug||null,
    companySlug:session.companySlug||null,
    expiresAt:session.expiresAt||0
  }));
}

export function clearViewerSession() {
  localStorage.removeItem(STORAGE_KEY);
}

// True for the shareable URL space (§2.3): /workspace itself and anything
// under it. The auth gate uses this to show ShareGate for guests on workspace
// paths instead of bouncing them to /signin.
export function isWorkspacePathname(pathname) {
  return /^\/workspace(\/|$)/.test(pathname||'');
}

// Legacy-hash boot translation (§2.3 migration). Takes the value found in
// window.location.hash ('#/finance') and returns the workspace-path
// equivalent, or null when there is nothing to translate (empty hash, '#/',
// '#') so the router's own root redirect decides. Auth routes keep their own
// URLs; unknown screen slugs pass through — WorkspaceScreen falls back to
// headquarters. companySlug defaults to the pre-auth 'workspace' placeholder.
export function resolveWorkspaceRedirect(hash,companySlug='workspace') {
  if (!hash || hash==='#' || hash==='#/') return null;
  const raw=hash.startsWith('#') ? hash.slice(1) : hash;
  const [pathPart,queryPart]=raw.split('?');
  const first=pathPart.split('/').filter(Boolean)[0];
  if (!first) return null;
  const slug=first.toLowerCase();
  if (slug==='signin' || slug==='signup') {
    return `/${slug}${queryPart ? `?${queryPart}` : ''}`;
  }
  return `/workspace/${encodeURIComponent(companySlug||'workspace')}/${encodeURIComponent(slug)}${queryPart ? `?${queryPart}` : ''}`;
}
